import uuid from "uuid";
import { push } from "connected-react-router";
import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, flatMap } from "rxjs/operators";
import { onSafetyMinutesListRequest } from "features/health-and-safety/actions";
import { TASK_SAFETY_MINUTES_ROUTE } from "features/health-and-safety";
import { ADD_SAFETY_MINUTES_FORM_SUBMIT } from "../actions/types";
import { profileFetch } from "features/account";
import {
	DBService,
	SAFETY_MINUTES_TABLE,
	replaceDataURLs,
	authHeaders,
	getOrganisationBaseUrl,
} from "frame";
import { filterPeople, getCurrentTimestamp, isProd } from "utils";
import * as R from "ramda";
import ReactGA from "react-ga";
import {
	onAddSafetyMinutesReset,
	onAddSafetyMinutesSaveFailed,
	onAddSafetyMinutesSaveSuccess,
} from "../actions";

const fetchAttachments = () => async () => {
	const db = new DBService();
	var files = await db.getAll(SAFETY_MINUTES_TABLE);
	return files;
};

const addSafetyMinutesEffect = (action$, state$) =>
	action$.pipe(
		ofType(ADD_SAFETY_MINUTES_FORM_SUBMIT),
		flatMap(fetchAttachments()),
		mergeMap((result) => {
			let attachments = R.clone(
				state$.value.addSafetyMinutesFormReducer.attachments
			);
			attachments = replaceDataURLs(attachments, result);

			const reducer = state$.value.addSafetyMinutesFormReducer;
			const safetyMinutesId = reducer.id || uuid.v4();
			const sendToRecipientsOnSave = reducer.sendToRecipientsOnSave;
			const recipients = (reducer.recipients || []).filter(Boolean);
			const recipientsOther = (reducer.recipientsOther || []).filter(Boolean);
			const baseUrl = getOrganisationBaseUrl(state$.value);

			const successActions = of(
				profileFetch(),
				onSafetyMinutesListRequest(),
				onAddSafetyMinutesSaveSuccess(),
				onAddSafetyMinutesReset(),
				push(TASK_SAFETY_MINUTES_ROUTE)
			);

			return ajax
				.post(
					`${baseUrl}/safety-minutes/createorupdate`,
					{
						id: safetyMinutesId,
						title: reducer.title,
						siteId: reducer.siteId,
						createdAt: reducer.createdAt,
						people: filterPeople(reducer.people),
						otherPeople: reducer.otherPeople,
						hazards: reducer.hazards,
						operationalIssues: reducer.notes.operationalIssues,
						generalIssuesDiscussed: reducer.notes.generalIssuesDiscussed,
						recipients: reducer.recipients,
						recipientsOther: reducer.recipientsOther,
						sendEmail: sendToRecipientsOnSave,
						attachments: attachments,
						latitude: state$.value.geolocation.latitude,
						longitude: state$.value.geolocation.longitude,
						timestamp: getCurrentTimestamp(),
						organisationId: state$.value.organisations.currentOrganisation,
					},
					authHeaders()
				)
				.pipe(
					mergeMap(() => {
						isProd &&
							ReactGA.event({
								category: "Tasks",
								action: "Save Clicked",
								label: "Add Safety Minutes",
							});

						if (sendToRecipientsOnSave && (recipients.length > 0 || recipientsOther.length > 0)) {
							return ajax
								.post(
									`${baseUrl}/safety-minutes/email/${safetyMinutesId}`,
									{
										toInternalAddresses: recipients,
										toExternalAddresses: recipientsOther,
									},
									authHeaders()
								)
								.pipe(
									mergeMap(() => successActions),
									catchError(() => successActions) // don't block save if email dispatch fails
								);
						}

						return successActions;
					}),
					/* eslint-disable */
					catchError((error) =>
						of(onAddSafetyMinutesSaveFailed(error.message))
					)
					/* eslint-enable */
				);
		})
	);

export default addSafetyMinutesEffect;
